import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "@/App";
import { copy, LOGO } from "@/i18n";

export default function ShopCancel() {
    const { lang } = useLang();
    const c = copy[lang].shop;

    return (
        <div data-testid="shop-cancel-page" className="min-h-screen bg-noir flex items-center justify-center px-4">
            <div className="max-w-md w-full text-center rounded-2xl border border-white/10 bg-card p-10">
                <img src={LOGO} alt="The Market Lugano" className="h-10 w-auto mx-auto mb-8" />
                <XCircle size={48} className="text-crimson mx-auto" />
                <h1 className="mt-6 font-display font-extrabold uppercase tracking-tight text-2xl sm:text-3xl">
                    {c.cancelTitle}
                </h1>
                <p className="mt-4 text-neutral-400 text-sm leading-relaxed">{c.cancelText}</p>
                <Link
                    data-testid="cancel-back-shop-link"
                    to="/shop"
                    className="mt-8 inline-flex items-center justify-center rounded-full bg-white text-noir hover:bg-crimson hover:text-white transition-colors text-xs font-bold uppercase tracking-widest px-7 py-3.5"
                >
                    {c.backShop}
                </Link>
            </div>
        </div>
    );
}
